import { makeServerPut, makeServerPost, makeServerRequest, makeServerDelete } from './util';

const apiPrefix = "api/v1/users";

export function fetchUsersSuccess(users) {
    return {
        type: "FETCH_USERS_SUCCESS",
        payload: users
    };
}

export function fetchUsersFailure(error) {
    return {
        type: "FETCH_USERS_FAILURE",
        errorMessage: error
    };
}

export const fetchUsers = (key, page) => {

    return (dispatch) => {
        dispatch({type: "FETCH_USERS", payload: key});

        if (key) {
            return makeServerRequest(apiPrefix + "?size=10&page=" + page + "&username=" + key).then(
                response => dispatch(fetchUsersSuccess(response.data))
            ).catch(
                error => {
                    dispatch(fetchUsersFailure(error.response.data.errorCode))
                    throw error
                }
            );
        } else {
            return makeServerRequest(apiPrefix + "?size=10&page=" + page).then(
                response => dispatch(fetchUsersSuccess(response.data))
            ).catch(
                error => {
                    dispatch(fetchUsersFailure(error.response.data.errorCode))
                    throw error
                }
            );
        }
    };
};

export function fetchUserSuccess(user) {
    return {
        type: "FETCH_USER_SUCCESS",
        payload: user
    };
}

export function fetchUserFailure(error) {
    return {
        type: "FETCH_USER_FAILURE",
        errorMessage: error
    };
}

export const newUser = () => {
    return {
        type: "NEW_USER"
    }
}

export const clearUser = () => {
    return {
        type: "CLEAR_USER"
    }
}

export const fetchUser = (id) => {
    return (dispatch) => {
        dispatch({type: "FETCH_USER"});

        return makeServerRequest(apiPrefix + "/" + id).then(
            response => dispatch(fetchUserSuccess(response.data))
        ).catch(
            error => {
                dispatch(fetchUserFailure(error.response.statusText))
                throw error 
            }
        );
    };
};

export function persistUserSuccess(user) {
    return {
        type: "PERSIST_USER_SUCCESS",
        payload: user,
        successMessage: "User data saved"
    };
}

export function persistUserFailure(error) {
    return {
        type: "PERSIST_USER_FAILURE",
        errorMessage: error
    };
}
export const persistUser = (user) => {

    return (dispatch) => {
        dispatch({type: "PERSIST_USER", payload: user});

        if(!user.id) { //If there isn't any ID then we make an POST 
            return makeServerPost(apiPrefix + "/", user).then (
                response => dispatch(persistUserSuccess(response.data))
            ).catch(
                error => {
                    dispatch(persistUserFailure(error.response.data.errorCode))
                    throw error
                }
            );
        } else {
            return makeServerPut(apiPrefix + "/" + user.id, user).then(
                response => dispatch(persistUserSuccess(response.data))
            ).catch(
                error => dispatch(persistUserFailure(error.response.data.errorCode))
            );
        }
    };
};

export const deleteUserSuccess = (user) => {
    return {
        type: "DELETE_USER_SUCCESS",
        payload: user
    };
};

export const deleteUserFailure = (error) => {
    return {
        type: "DELETE_USER_FAILURE",
        error
    };
};

export const deleteUser = (userId) => {
    return (dispatch) => {
        dispatch({type: "DELETE_USER", payload: userId});

        return makeServerDelete(apiPrefix + "/" + userId).then(
            response => dispatch(deleteUserSuccess(response.data))
        ).catch(
            error => dispatch(deleteUserFailure(error.response.data.errorCode))
        );
    };
};

export const inviteUser = (username) => {
    return () => {
        return makeServerRequest(apiPrefix + "/invite?username=" + username);
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/users.js